import React, { useState } from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  const [showMore, setShowMore] = useState(false);

  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Project</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>

          {/* First 3 posts */}
          <div className="row textCenter">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <BlogBox
                  title="New Office!"
                  text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                  tag="company"
                  author="Luke Skywalker, 2 days ago"
                  action={() => alert("clicked")}
                />
              </div>
            ))}
          </div>

          {/* Load more content */}
          {showMore && (
            <div className="row textCenter">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index + 3}
                  className="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                >
                  <BlogBox
                    title="New Office!"
                    text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                    tag="company"
                    author="Luke Skywalker, 2 days ago"
                    action={() => alert("clicked")}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Load More Button */}
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              {!showMore && (
                <FullButton
                  title="Load More"
                  action={() => setShowMore(true)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What They Say?</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
